import { createContext, useContext, useState } from "react";
import { setToLocalStorage, removeFromLocalStorage } from "../../lib/localStorage";
import { useFetchPermissions } from "api/permissions/usePermissions";
import AuthenticationContext from "./authenticationContext";

const PrivateKeyContext = createContext();

export function PrivateKeyContextProvider({ children }) {
  const initialState = JSON.parse(localStorage.getItem("pkey")) || [];

  const [privateKey, setPrivateKey] = useState(initialState);
  const { response: fetchPermissionsResponse, } = useFetchPermissions();
  const { permissionsData } = useContext(AuthenticationContext);

  const accountInContext = (value) => {
    return privateKey.find((obj) => obj.account === value);
  };

  const handlePrivateKey = (pkey) => {
    try {
      const duplicateIndex = privateKey.findIndex((el) => el.account === pkey.account);

      if (duplicateIndex !== -1) {
        const updatedPrivateKey = [...privateKey];
        updatedPrivateKey[duplicateIndex].privateKey = pkey.privateKey;
        setPrivateKey(updatedPrivateKey);
        setToLocalStorage('pkey', updatedPrivateKey);
        return;
      }

      const updatedPrivateKey = [...privateKey, pkey];
      setPrivateKey(updatedPrivateKey);
      setToLocalStorage('pkey', updatedPrivateKey);
    } catch (error) {
      console.error('Error in handlePrivateKey:', error);
    }
  };

  const dropSavedKey = (acc) => {
    try {
      const updatedPrivateKey = [...privateKey].filter(userObj => userObj.account !== acc);
      setPrivateKey(updatedPrivateKey);
      setToLocalStorage('pkey', updatedPrivateKey);
    } catch (error) {
      console.error('Error in dropSavedKey:', error);
    }
  };

  const clearSavedKeys = () => {
    try {
      setPrivateKey([]);
      removeFromLocalStorage('pkey');
    } catch (error) {
      console.error('Error in clearSavedKeys:', error);
    }
  };

  const valueToShare = {
    privateKey: privateKey,
    handlePrivateKey: handlePrivateKey,
    accountInContext: accountInContext,
    dropSavedKey: dropSavedKey,
    clearSavedKeys: clearSavedKeys
  };

  return (
    <PrivateKeyContext.Provider value={valueToShare}>
      {children}
    </PrivateKeyContext.Provider>
  );
}

export default PrivateKeyContext;
